import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

/** 获取url **/
export function getRedirectUrl () {
  return request.request({
    url: '/api/cashier/redirectUrl',
    method: 'POST',
    data: { wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken }
  })
}

/** 获取url **/
export function getChannelUserId (redirectData) {
  return request.request({
    url: '/api/cashier/channelUserId',
    method: 'POST',
    data: Object.assign({ wayCode: wayCode.getPayWay().wayCode, token: config.cacheToken }, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount, remark, invoiceInfo) {
  const data = {
    wayCode: wayCode.getPayWay().wayCode,
    token: config.cacheToken,
    amount: amount,
    buyerRemark: remark,
    channelUserId: channelUserIdUtil.getChannelUserId(),
    needInvoice: invoiceInfo ? 1 : 0
  }
  if (invoiceInfo) {
    Object.assign(data, {
      invoiceTitleType: invoiceInfo.titleType === 'enterprise' ? 1 : 2,
      invoiceTitleName: invoiceInfo.titleName,
      invoiceTaxNo: invoiceInfo.taxNo,
      invoiceGoodsName: invoiceInfo.goodsName,
      invoiceRemark: invoiceInfo.invoiceRemark,
      invoicePhone: invoiceInfo.phone,
      invoiceEmail: invoiceInfo.email
    })
  }
  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: data
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo () {
  return request.request({
    url: '/api/cashier/payOrderInfo',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 我的交易：按 t_pay_order.channel_user + 当前收银台商户/应用查询 **/
export function getMyTransactions (pageSize) {
  return request.request({
    url: '/api/cashier/myTransactions',
    method: 'POST',
    data: {
      token: config.cacheToken,
      channelUserId: channelUserIdUtil.getChannelUserId(),
      pageSize: pageSize || 30
    }
  })
}

/** 支付成功后提交开票请求 **/
export function submitInvoice (invoiceData) {
  return request.request({
    url: '/api/cashier/invoice',
    method: 'POST',
    data: invoiceData
  })
}

/** 取消订单 **/
export function cancelPay () {
  return request.request({
    url: '/api/cashier/cancelPay',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 根据企业名称模糊搜索购方信息 **/
export function searchPurchaserInfo (term) {
  return request.request({
    url: '/api/cashier/purchaser-search',
    method: 'GET',
    params: { term }
  })
}
